import "./Bee.css"

export default function BEE() {
    return (
        <div className="Bee">
            <div className="section bee-content-wrapper">
                <div className="bee-text-wrapper">
                    <h2 className="bee-title">B-BBEE</h2>
                    <p className="bee-text">
                        To be accountable to the true need of organisation
                        efficiency and effectiveness. Ensuring top of the
                        class candidates that will adequately fill their roles
                        in achievement towards the larger goals of the client
                        organisation. <br/><br/>
                        To be frontline in addressing unemployment in South
                        Africa by serving job seekers. Ensuring candidates
                        are placed with organisations that are the best
                        match for them.
                    </p>
                    <button className="upload-btn button">BEE Certificate</button>
                </div>
            </div>
        </div>
    )
}